import { ProIp } from "./ApiURL";


//postMapping { id, member_type, password, oldpassword }

export const changePasswordAPI = ProIp + "Password/changePassword";

export const forgotPasswordAPI = ProIp + "Password/forgotPassword";